import { render, staticRenderFns } from "./Jewels.vue?vue&type=template&id=7192f12e&"
import script from "./Jewels.vue?vue&type=script&lang=js&"
export * from "./Jewels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports